import _ from 'underscore';
import $ from 'jquery';
import Constants from 'root/constants';
import UI from 'root/ui';
import Cache from 'root/cache';
import Util from 'root/module/util';
import Modals from 'root/modals';
import View from 'view/base';

export default View.extend({
    className: 'workspace-member-preview',

    events: {
        'click .member-remove'              : 'onDeleteInvitation',
        'click .resend'                     : 'onResendInvitation',
        'click .dropdown-project-access li' : 'onSelctProject',
        'click .role-edit'                  : 'onEditRole',
        'click .session-replay-access'      : 'onToggleSessionReplayAccess'
    },

    dom_handlers: {
        onDeleteInvitation: function(e) {
            Modals.deleteUserInvitation(this.model.id);
        },

        onResendInvitation: function(e) {
            Modals.resendUserInvitation(this.model.id);
        },

        onEditRole: function(e) {
            var role = $(e.currentTarget).data('val');

            if (!Cache.account.hasFeature('client_role') && role === Constants.CLIENT) {
                Modals.unlockFeature();
            }

            if ($(e.currentTarget).hasClass('disabled')) {
                return;
            }

            Cache.app.request({
                action: 'user_invitation/updateRole',
                data: {
                    id: this.model.id,
                    role: role
                },
                success: (response) => {
                    this.model.set(response);
                    UI.success('Invitation updated');
                }
            });
        },

        onSelctProject: function(e) {
            var project_id = $(e.currentTarget).data('val');
            var project_ids = this.model.get('project_ids').split(',').map((project_id) => {
                return parseInt(project_id, 10);
            });

            var is_remove = project_ids.includes(project_id);

            if (is_remove) {
                // can't remove the last project
                if (project_ids.length <= 1) {
                    return;
                }
            }

            Cache.app.request({
                action: is_remove ? 'user_invitation/removeProject' : 'user_invitation/addProject',
                data: {
                    id: this.model.id,
                    project_id: project_id
                },
                success: (response) => {
                    this.model.set(response);
                    UI.success('Invitation updated');
                }
            });
        },

        onToggleSessionReplayAccess: function(e) {
            var has_access = $(e.currentTarget).prop('checked');

            this.model.setAccess(Constants.ACCESS_SESSION_REPLAY, has_access ? 1 : 0, 0);

            UI.success('Session replay access updated');
        },
    },

    initialize: function() {
        this.listenTo(this.model, 'change', this.render);
    },

    render: function() {
        var project_options = '';
        var access_total = 0;

        Cache.project.where({is_archived: false}).forEach((project_model) => {
            var has_access = false;
            var project_ids = this.model.get('project_ids').split(',').map((project_id) => {
                return parseInt(project_id, 10);
            });

            if (this.model.get('role') === Constants.ADMIN) {
                has_access = true;
            } else if (project_ids.indexOf(project_model.id) !== -1) {
                has_access = true;
            }

            if (!Cache.account.hasFeature('user_restriction')) {
                has_access = true;
            }

            if (has_access) {
                access_total++;
            }

            project_options += '<li' + (has_access ? ' class="selected"' : '') + ' data-val="' + project_model.id + '">' + project_model.escape('name') + '</li>';
        });

        var can_edit_role           = Cache.app.isAdmin();

        var uid = _.uniqueId('session_replay_access_');

        var content =
        '<div><img class="user user-36" src="' + Util.gravatar(this.model.get('email')) + '"></div>' +

        '<div>' +
            '<div class="member-name">' + this.model.escape('email') + '<span class="badge-primary-invert badge-small member-badge">Pending</span></div>' +
            '<div class="last-login">' +
                '<span>' + this.model.getRoleName() + '</span>' +
                '<span>Invitation sent: ' + Util.moment(this.model.get('time'), 'DD MMM YYYY HH:hh A') + '</span>' +
            '</div>' +
        '</div>' +

        '<div class="flex-top-end">' +
            '<span class="text-info">' +
                (this.model.get('role') === Constants.ADMIN ?
                'All Projects & All Sessions' :
                access_total + ' Project' + (access_total === 1 ? '' : 's') + (this.model.hasAccess(Constants.ACCESS_SESSION_REPLAY, 0) ? ' & All Sessions' : '')) +
            '</span>' +
            (Cache.app.isAdmin() ?
            '<div class="button-dropdown margin-left-16" data-append="true">' +
                '<button type="button" class="ellipsis"><i class="fa-regular fa-ellipsis-h"></i></button>' +
                '<div>' +
                    '<ul class="dropdown">' +
                        '<li class="resend">Resend Invitation</li>' +
                        '<li class="separator"></li>' +
                        '<li class="member-remove">Remove from workspace</li>' +
                    '</ul>' +
                '</div>' +
            '</div>' : '') +
        '</div>';

        this.$el.html(content);

        return this;
    }
});